// import { injectReducer } from '../../store/reducers';

export default store => ({
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const Home = require('./containers/HomeContainer').default;
    /*  Return getComponent   */
    cb(null, Home);
  },
});



// WEBPACK FOOTER //
// src/routes/home/Home.js